import { apiClient } from './client';
import { MandateMatch } from '../types';

export async function getMandateMatches(mandateId: string): Promise<MandateMatch[]> {
  const { data } = await apiClient.get('/mandate-matches', { params: { mandate_id: mandateId } });
  return data.data;
}

export async function getSuggestions(mandateId: string): Promise<{ data: MandateMatch[]; mandate: unknown }> {
  const { data } = await apiClient.get(`/mandate-matches/suggestions/${mandateId}`);
  return data;
}

export async function addMandateMatch(payload: {
  mandate_id: string;
  company_id: string;
  profile_id?: string | null;
  status?: string;
  notes?: string | null;
  match_score?: number;
}): Promise<MandateMatch> {
  const { data } = await apiClient.post('/mandate-matches', payload);
  return data.data;
}

export async function updateMandateMatch(id: string, payload: { status?: string; notes?: string | null }): Promise<MandateMatch> {
  const { data } = await apiClient.put(`/mandate-matches/${id}`, payload);
  return data.data;
}

export async function removeMandateMatch(id: string): Promise<void> {
  await apiClient.delete(`/mandate-matches/${id}`);
}
